import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import translate from '@/lib/intl/translate';

export default function ShowHideToggleIcon({
  IconProps,
  className,
  classes,
  hideText,
  isOpen,
  showText,
}) {
  return (
    <div
      className={classnames(
        'text-primary-main type-body2',
        className,
        classes?.root,
      )}
    >
      <ArrowDropDownIcon
        className={classnames(classes?.icon, 'transition-transform', {
          'rotate-180': isOpen,
        })}
        {...IconProps}
      />
      <span className={classnames(classes?.text)}>
        {isOpen ? hideText : showText}
      </span>
    </div>
  );
}

ShowHideToggleIcon.propTypes = {
  IconProps: PropTypes.object,
  className: PropTypes.string,
  classes: PropTypes.shape({
    root: PropTypes.string,
    icon: PropTypes.string,
    text: PropTypes.string,
  }),
  hideText: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  showText: PropTypes.string,
};

ShowHideToggleIcon.defaultProps = {
  IconProps: {},
  className: '',
  classes: {},
  hideText: translate('HIDE'),
  showText: translate('SHOW'),
};
